//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from "axios"
import draggable from 'vuedraggable'

export default {
  name: 'Playlist',
  components: {
    draggable
  },
  data: function() {
    return {
      patterns: [],
      loaded: false,
      editing: false,
      renameprompt: false,
      name: ""
    }
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        disabled: !this.editing,
        ghostClass: "ghost"
      };
    },
  },
  methods: {
    renameAction: function() {
      if(this.editing == true) {
        this.renameprompt = true;
      }
    },
    renamePlaylist: async function() {
      this.$q.loading.show({
        delay: 100 // ms
      })

      await this.$root.deleteFile("/sd/" + this.$route.params.name);
      let playlistFile = "";
      this.patterns.forEach((pattern) => {
        playlistFile += pattern.name + "\n";
      })

      var formData = new FormData();
      var blob = new Blob([playlistFile], {type: "text/plain"});
      formData.append("file", blob, this.$route.params.name.split("-")[0] + "-" + this.name.replace(/-/g, "") + ".seq");
      await axios.post(this.$root.baseURL + "/uploadtofileman", formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
      });
      this.$q.loading.hide()
      this.$router.go(-1);
      this.$toasted.success('Renamed!', {
        duration: 1500
      })
    },
    openTrack: function(pname) {
      if(this.editing == false) {
        this.$router.push("/library/track/" + pname);
      }
    },
    saveEdits: async function() {
      this.$q.loading.show({
        delay: 100 // ms
      })
      let playlistFile = "";
      this.patterns.forEach((pattern) => {
        playlistFile += pattern.name + "\n";
      })

      var formData = new FormData();
      var blob = new Blob([playlistFile], {type: "text/plain"});
      formData.append("file", blob, this.$route.params.name);
      await axios.post(this.$root.baseURL + "/uploadtofileman", formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
      });
      this.$q.loading.hide()
      this.$toasted.success('Changes saved!', {
        duration: 750
      })
    },
    refreshFiles: async function(done) {
        if(this.$root.community.authToken == "") {
          //Log in to Webcenter
          await axios.post("https://webcenter.sisyphus-industries.com/auth_user", {
              email: this.$root.community.email, password: this.$root.community.password
          }).then((resp) => {
              this.$root.community.authToken = resp.data.resp[0].auth_token;
          });
        }

        this.patterns = [];
        if(this.$route.params.name != "All Tracks.seq") {
            await axios.get(this.$root.baseURL + "/files/sd/" + this.$route.params.name).then((response) => {
                const ptrns = response.data.split("\n");
                ptrns.forEach(file => {
                    if(file != "") {
                        this.patterns.push({ name : file, size: 1234 });
                    }
                });
            });
        } else {
            await axios.get(this.$root.baseURL + "/filelist").then(async (response) => {
                response.data.files.forEach(async (file) => {
                    if(file.name.includes(".THR") || file.name.includes(".thr")) {
                        //const trackdata = (await axios.get("https://webcenter.sisyphus-industries.com/tracks/" + file.name.replace(".THR", "") + ".json", { headers: {Authorization: this.$root.community.authToken }})).data;
                        this.patterns.push(file);
                        //console.log(trackdata);
                    }
                });
            });
        }
        done();
    }
  },
  mounted: async function() {
    if(this.$route.params.name != "All Tracks.seq") {
      this.name = this.$route.params.name.split("-")[1].replace(".seq", "")
    }
    this.$q.loading.show({
        delay: 100 // ms
    })
    await this.refreshFiles(function() {});
    this.$q.loading.hide();
    this.loaded = true;
  }
}
